'use client';

import useItemListImpression from '@/hooks/useItemListImpression';

/**
 * Reports a `view_item_list` impression for one product in a list that does not
 * render `ProductCard` — the search suggestion dropdown, the PDP combo and
 * bundle blocks. Renders as whatever element the list already used.
 */
const ProductListItem = ({
  product,
  index = 0,
  as: Tag = 'div',
  children,
  ...props
}) => {
  const listRef = useItemListImpression(product, index);

  return (
    <Tag ref={listRef} {...props}>
      {children}
    </Tag>
  );
};

export default ProductListItem;
